import { AfterContentInit, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';

import { CreateSchainService, GeneralSchainService } from '../../services';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { DropdownInterface } from '../../../../core/models';
import { AuthService } from '../../../../core/services';
import { sourceSchainRowLimitDescription } from '../../helpers/source-schain-partner-messages';

@Component({
  selector: 'app-create-ssp-source',
  standalone: false,
  templateUrl: './create-ssp-source.component.html',
  styleUrl: './create-ssp-source.component.scss'
})
export class CreateSspSourceComponent implements OnInit, AfterContentInit {
  protected contentHeight = 'auto';
  protected listOfCheckboxesMaxHeight = 800;

  public data = inject(NZ_MODAL_DATA) as {
    companies: DropdownInterface.ICompaniesDataGeneralSource[],
    checkedCompanies: number[]
  };

  @ViewChild('fileInput') protected fileInput: ElementRef;

  constructor(
    protected generalSchainService: GeneralSchainService,
    protected createSchainService: CreateSchainService,
    private dialogRef: NzModalRef<CreateSspSourceComponent>,
    private authService: AuthService,
  ) { }

  protected get rowLimitDescription(): string {
    return sourceSchainRowLimitDescription(this.authService.partner.id);
  }


  public ngOnInit(): void {
    this.createSchainService.initComponent(this.data);
  }

  public ngAfterContentInit(): void {
    this.contentHeight = window.innerHeight - 100 + 'px';
    this.listOfCheckboxesMaxHeight = window.innerHeight - 340;
    window.addEventListener('resize', () => {
      this.contentHeight = window.innerHeight - 100 + 'px';
      this.listOfCheckboxesMaxHeight = window.innerHeight - 340;
    });
  }

  protected onUploadFile(event: Event): void {
    this.createSchainService.onUploadFileHandler(event, () => this.fileInput.nativeElement.value = '', 'ssp');
  }

  protected onDownloadFile(): void {
    this.createSchainService.onDownloadFileHandler();
  }

  protected onDeleteFile(): void {
    this.createSchainService.onDeleteFileHandler();
  }

  protected onCancelUpload(): void {
    this.createSchainService.onCancelUploadHandler('ssp');
  }

  protected onCloseModal(): void {
    this.createSchainService.onCloseModalHandler(() => this.dialogRef.close());
  }

  protected onCreateSspSource(): void {
    this.createSchainService.onCreateSourceSchainHandler(() => this.dialogRef.close(), 'ssp');
  }
}
